
const {ENV_DATA} = process.env;

export default {
  BASE_URL: ENV_DATA.API_PATH,
  apiKey:ENV_DATA.API_APP_KEY,
  apiSecret:ENV_DATA.API_APP_SECRET,
  key:ENV_DATA.API_APP_KEY,
  timeout:10000,
  ticketErrCode:[40003] // 需要重新获取 auth token的异常码
};